"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortWithSelector = sortWithSelector;
/*
 * Used as an argument to sort() to a do a normal a/b sort.
 */
function sortWithSelector(selector) {
  return function _sortHelper(a, b) {
    a = selector(a);
    b = selector(b);
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    } else {
      return 0;
    }
  };
}